import { AxiosResponse } from "axios";
import MiMPrivateService from "./MiMPrivateService";

class ReportService extends MiMPrivateService {
  getMigrationReport(reportName: string): Promise<AxiosResponse<any>> {
    return this.http.get(`v1/reports/migration/${reportName}`);
  }
}

export default ReportService;
